import { FC, useRef } from 'react'
import { AriaButtonProps, useButton } from 'react-aria'
import cx from 'classnames'

import * as SC from './styled'

export type BurgerProps = AriaButtonProps & {
  className?: string
  texts?: {
    open: string
    close: string
  }
}

const Burger: FC<BurgerProps> = (props) => {
  const { className, texts, ...button } = props
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps } = useButton(button, ref)

  return (
    <SC.Container
      className={cx('Burger', className)}
      {...buttonProps}
      ref={ref}
    >
      <SC.Label>
        <span hidden={buttonProps['aria-expanded'] === true}>
          {texts?.open}
        </span>
        <span hidden={buttonProps['aria-expanded'] === false}>
          {texts?.close}
        </span>
      </SC.Label>
      <SC.Icon aria-hidden>
        <i />
        <i />
        <i />
      </SC.Icon>
    </SC.Container>
  )
}

export default Burger
